// extracted by mini-css-extract-plugin
export default {"countdownContainer":"style_countdownContainer__lWevG","countdown":"style_countdown__DK69j","closeBtn":"style_closeBtn__xtybn"};